import { RenameCanvasDialog } from "@/action-dialog/dialogs/RenameCanvasDialog";
import { RenameChatDialog } from "@/action-dialog/dialogs/RenameChatDialog";
import { RenameFileRecordDialog } from "@/action-dialog/dialogs/RenameFileRecordDialog";
import type { Canvas, FileRecord, InboxItem } from "@cohesive/api-client";
import { useRef } from "react";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type RenameCanvasCallableProps = {
  canvas: Canvas;
  detailsLoading?: boolean;
  onRenamed?: (name: string) => void;
};

export const RenameCanvasCallable = createCallable<
  RenameCanvasCallableProps,
  boolean
>(({ call, canvas, detailsLoading, onRenamed }) => {
  const succeededRef = useRef(false);

  return (
    <RenameCanvasDialog
      canvas={canvas}
      detailsLoading={detailsLoading}
      onRenamed={(name) => {
        succeededRef.current = true;
        onRenamed?.(name);
      }}
      onClose={() => {
        call.end(succeededRef.current);
        succeededRef.current = false;
      }}
    />
  );
}, UNMOUNTING_DELAY_MS);

RenameCanvasCallable.displayName = "RenameCanvasCallable";

export type RenameChatCallableProps = {
  item: InboxItem;
  onRenamed?: (name: string) => void;
};

export const RenameChatCallable = createCallable<
  RenameChatCallableProps,
  boolean
>(({ call, item, onRenamed }) => {
  const succeededRef = useRef(false);

  return (
    <RenameChatDialog
      item={item}
      onRenamed={(name) => {
        succeededRef.current = true;
        onRenamed?.(name);
      }}
      onClose={() => {
        call.end(succeededRef.current);
        succeededRef.current = false;
      }}
    />
  );
}, UNMOUNTING_DELAY_MS);

RenameChatCallable.displayName = "RenameChatCallable";

export type RenameFileRecordCallableProps = {
  record: FileRecord;
  allRecords: FileRecord[];
};

export const RenameFileRecordCallable = createCallable<
  RenameFileRecordCallableProps,
  boolean
>(({ call, record, allRecords }) => {
  const succeededRef = useRef(false);

  return (
    <RenameFileRecordDialog
      record={record}
      allRecords={allRecords}
      onSuccess={() => {
        succeededRef.current = true;
      }}
      onClose={() => {
        call.end(succeededRef.current);
        succeededRef.current = false;
      }}
    />
  );
}, UNMOUNTING_DELAY_MS);

RenameFileRecordCallable.displayName = "RenameFileRecordCallable";
